<template>
    <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
        <div class="modal-overlay" @click="back()"></div>
        <div class="modal">
            <article v-if="resource">

                    <header>
                        <figure>
                            <i v-if="!resource.picture" class="icon icon-icon_person"></i>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.firstname ? resource.firstname + " " + resource.lastname : 'Nouveau' }}</h1>

                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-autocomplete label="Détenteur" multiple="false" v-model="resource.person" :default="resource.person_id" :service="persons"></form-autocomplete>

                                <div class="credit-cards">
                                    <div class="card">
                                        <span class="card-numbers">1234 567 8910 1112</span>
                                        <span class="card-ccv">123</span>
                                    </div>
                                    <div class="card">
                                        <span class="card-numbers">9878 567 8910 2222</span>
                                        <span class="card-ccv">453</span>
                                    </div>
                                </div>

                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>


    import AccountService from './AccountService.js';
    import PersonService from '../../person/PersonService.js';

    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        components: {
        },
        data () {
            return {
                persons: null,
                attributes: [],
                resource: {
                },
                isLoading: false
            }
        },
        mounted: function(){
            this.persons = PersonService;
        },
        methods:{
            resourceLoaded: function(){
                this.localesLoaded = true;

                this.resource.person = {id: this.resource.person.id, name: this.resource.person.firstname + " " + this.resource.person.lastname}
            },
            beforeUpdate: function(Resource){
                return true
            },
            getResource: function(){
                return AccountService
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/fidelity/account/Edit.vue